/* PurpleLights Schienenplaner v3
 * Gemeinsamer Planer für 1-Phasen- und 3-Phasen-Schienensystem.
 * Schritte: system → rails → spots → summary (zentraler Zustand, goToStep()).
 * WICHTIG: Alle Delegations-Selektoren nutzen den Namespace data-pltp-* und werden
 * gegen den Planer-Container geprüft. Grund: Horizon umschließt die Section mit
 * <main data-template="…"> – generische Selektoren wie [data-template] oder
 * [data-action] können Theme-Elemente treffen und Klicks still verschlucken
 * (Ursache der toten Buttons in v2). */
(function () {
  'use strict';

  var rootEl = document.querySelector('[data-pl-track-planner]');
  if (!rootEl || rootEl.__pltpInit) return;
  rootEl.__pltpInit = true;

  /* ---------- Konfiguration ---------- */
  var cfgEl = document.getElementById('pl-tp-config');
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = null; }
  if (!CFG || !CFG.systems) {
    rootEl.innerHTML = '<p class="pl-tp-error">Der Planer ist noch nicht konfiguriert.</p>';
    return;
  }
  var SYSTEMS = CFG.systems; // { one_phase: {...}, three_phase: {...} }
  var STEPS = ['system', 'rails', 'spots', 'summary'];
  var STEP_NUM = { system: 1, rails: 2, spots: 3, summary: 4 };
  var DIRS = { 0: [1, 0], 90: [0, 1], 180: [-1, 0], 270: [0, -1] };
  var DIR_ARROW = { 0: '→', 90: '↓', 180: '←', 270: '↑' };
  var STORE_KEY = 'plTrackPlannerV2';
  var MSG_CLOSED = 'Geschlossene Schienenformen werden in dieser Planerversion nicht unterstützt.';

  /* ---------- Zentraler Zustand ---------- */
  var state = freshState();
  var history = [], future = [];
  var ui = { pending: null, pendingEnd: null, railChoice: 'rail1m', selected: null, hover: null, spotFilter: { power: null, color: null }, confirmNoSpots: false };
  var idSeq = 1;

  function freshState() {
    return { version: 2, currentStep: 'system', selectedSystem: null, feedEnd: 'start', rails: [], spots: [] };
  }
  function sys() { return state.selectedSystem ? SYSTEMS[state.selectedSystem] : null; }
  function railDef(key) { return sys() ? sys().rails[key] : null; }
  function spotDef(key) { if (!sys()) return null; return sys().spots.filter(function (s) { return s.key === key; })[0]; }
  function newId(p) { return p + '-' + (idSeq++) + '-' + Date.now().toString(36); }
  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  function railW() { return sys() && sys().railWidthMm ? sys().railWidthMm : 32; }

  /* ---------- Geometrie (bewährt aus v1/v2) ---------- */
  function railEnd(r) { var d = DIRS[r.rotation]; return [r.x + d[0] * r.lengthMm, r.y + d[1] * r.lengthMm]; }
  function chainStart() { return state.rails.length ? [state.rails[0].x, state.rails[0].y] : null; }
  function chainEnd() { return state.rails.length ? railEnd(state.rails[state.rails.length - 1]) : null; }
  function reverseDir(d) { return (d + 180) % 360; }
  function ptEq(a, b) { return Math.abs(a[0] - b[0]) < 0.5 && Math.abs(a[1] - b[1]) < 0.5; }
  function segsIntersect(p1, p2, p3, p4) {
    function o(a, b, c) { var v = (b[1] - a[1]) * (c[0] - b[0]) - (b[0] - a[0]) * (c[1] - b[1]); return Math.abs(v) < 1e-6 ? 0 : (v > 0 ? 1 : 2); }
    function onSeg(a, b, c) { return Math.min(a[0], c[0]) - 0.5 <= b[0] && b[0] <= Math.max(a[0], c[0]) + 0.5 && Math.min(a[1], c[1]) - 0.5 <= b[1] && b[1] <= Math.max(a[1], c[1]) + 0.5; }
    var o1 = o(p1, p2, p3), o2 = o(p1, p2, p4), o3 = o(p3, p4, p1), o4 = o(p3, p4, p2);
    if (o1 !== o2 && o3 !== o4) return true;
    if (o1 === 0 && onSeg(p1, p3, p2)) return true;
    if (o2 === 0 && onSeg(p1, p4, p2)) return true;
    if (o3 === 0 && onSeg(p3, p1, p4)) return true;
    if (o4 === 0 && onSeg(p3, p2, p4)) return true;
    return false;
  }
  function checkCandidate(endType, dir, lengthMm) {
    var s, e, adjacentIdx, otherFree;
    if (endType === 'end') {
      s = chainEnd().slice();
      e = [s[0] + DIRS[dir][0] * lengthMm, s[1] + DIRS[dir][1] * lengthMm];
      adjacentIdx = state.rails.length - 1; otherFree = chainStart();
      if (dir === reverseDir(state.rails[adjacentIdx].rotation)) return 'Schiene würde die vorhandene Schiene überlagern.';
    } else {
      e = chainStart().slice();
      s = [e[0] - DIRS[dir][0] * lengthMm, e[1] - DIRS[dir][1] * lengthMm];
      adjacentIdx = 0; otherFree = chainEnd();
      if (dir === reverseDir(state.rails[0].rotation)) return 'Schiene würde die vorhandene Schiene überlagern.';
    }
    var freePoint = endType === 'end' ? e : s;
    if (otherFree && ptEq(freePoint, otherFree)) return MSG_CLOSED;
    for (var i = 0; i < state.rails.length; i++) {
      var r = state.rails[i], rs = [r.x, r.y], re = railEnd(r);
      if (i === adjacentIdx) {
        var d2 = DIRS[dir];
        var s2 = endType === 'end' ? [s[0] + d2[0], s[1] + d2[1]] : s;
        var e2 = endType === 'end' ? e : [e[0] - d2[0], e[1] - d2[1]];
        if (segsIntersect(s2, e2, rs, re)) return 'Schiene würde die Anlage überlagern.';
      } else if (segsIntersect(s, e, rs, re)) {
        return 'Schienen dürfen sich nicht kreuzen oder berühren.';
      }
    }
    return null;
  }
  function outwardDir(endType) {
    return endType === 'end' ? state.rails[state.rails.length - 1].rotation : reverseDir(state.rails[0].rotation);
  }
  function relToStored(endType, rel) {
    var g = outwardDir(endType);
    if (rel === 'links') g = (g + 270) % 360;
    else if (rel === 'rechts') g = (g + 90) % 360;
    return endType === 'end' ? g : reverseDir(g);
  }
  function validRel(endType, lengthMm) {
    return ['gerade', 'links', 'rechts'].filter(function (rel) {
      return checkCandidate(endType, relToStored(endType, rel), lengthMm) === null;
    });
  }
  function connectors() {
    var out = [];
    for (var i = 0; i + 1 < state.rails.length; i++) {
      var a = state.rails[i], b = state.rails[i + 1];
      out.push({ type: a.rotation === b.rotation ? 'mid' : 'l', at: [b.x, b.y], dirA: a.rotation });
    }
    return out;
  }

  /* ---------- History / Persistenz ---------- */
  function snapshot() { return JSON.stringify(state); }
  function commit() {
    history.push(snapshot());
    if (history.length > 100) history.shift();
    future = [];
    saveLocal(); renderAll();
  }
  function undo() {
    if (!history.length) return;
    future.push(snapshot());
    state = JSON.parse(history.pop());
    ui.selected = null; closeChooser(); saveLocal(); renderAll(); announce('Schritt rückgängig gemacht.');
  }
  function redo() {
    if (!future.length) return;
    history.push(snapshot());
    state = JSON.parse(future.pop());
    ui.selected = null; closeChooser(); saveLocal(); renderAll(); announce('Schritt wiederhergestellt.');
  }
  function saveLocal() {
    try {
      if (!state.selectedSystem && !state.rails.length && !state.spots.length) localStorage.removeItem(STORE_KEY);
      else localStorage.setItem(STORE_KEY, snapshot());
    } catch (e) {}
  }

  /* ---------- Mutationen ---------- */
  function selectSystem(key) {
    if (!SYSTEMS[key]) return;
    history.push(snapshot());
    state.selectedSystem = key;
    goToStep('rails');
    announce(SYSTEMS[key].name + ' ausgewählt.');
  }
  function changeSystem() {
    if (state.rails.length || state.spots.length) {
      if (!window.confirm('Beim Wechsel des Schienensystems wird die aktuelle Planung gelöscht. Möchten Sie fortfahren?')) return;
    }
    history.push(snapshot());
    var v = state.version;
    state = freshState(); state.version = v;
    future = [];
    goToStep('system');
    announce('Bitte wählen Sie ein Schienensystem.');
  }
  function addFirstRail(key, x, y) {
    var def = railDef(key); if (!def) return null;
    history.push(snapshot()); future = [];
    state.rails.push({ id: newId('rail'), key: key, sku: def.sku, lengthMm: def.lengthMm, x: snap(x), y: snap(y), rotation: 0 });
    saveLocal(); renderAll(); announce(def.label + ' platziert.');
    return state.rails[0].id;
  }
  function attachRail(endType, dir, key) {
    var def = railDef(key); if (!def) return null;
    var err = checkCandidate(endType, dir, def.lengthMm);
    if (err) { showError(err); return null; }
    var before = connCount();
    history.push(snapshot()); future = [];
    var rail;
    if (endType === 'end') {
      var s = chainEnd();
      rail = { id: newId('rail'), key: key, sku: def.sku, lengthMm: def.lengthMm, x: s[0], y: s[1], rotation: dir };
      state.rails.push(rail);
    } else {
      var e = chainStart();
      rail = { id: newId('rail'), key: key, sku: def.sku, lengthMm: def.lengthMm, x: e[0] - DIRS[dir][0] * def.lengthMm, y: e[1] - DIRS[dir][1] * def.lengthMm, rotation: dir };
      state.rails.unshift(rail);
    }
    saveLocal(); renderAll(); announce(def.label + ' angeschlossen.');
    var after = connCount();
    if (after.mid > before.mid) toast('Mittelverbinder automatisch ergänzt');
    else if (after.l > before.l) toast('L-Verbinder automatisch ergänzt');
    return rail.id;
  }
  function connCount() { var c = { mid: 0, l: 0 }; connectors().forEach(function (x) { c[x.type === 'mid' ? 'mid' : 'l']++; }); return c; }
  function addSpot(key, railId, posMm) {
    var def = spotDef(key);
    var rail = state.rails.filter(function (r) { return r.id === railId; })[0];
    if (!def || !rail) { showError('Strahler können nur auf Schienen platziert werden.'); return null; }
    history.push(snapshot()); future = [];
    // Lichtkegel standardmäßig senkrecht (90°) von der Schiene weg
    var spot = { id: newId('spot'), key: key, sku: def.sku, railId: railId, positionMm: clampPos(posMm, rail.lengthMm), orientation: (rail.rotation + 90) % 360 };
    state.spots.push(spot);
    saveLocal(); renderAll(); announce(def.label + ' platziert.');
    return spot.id;
  }
  function clampPos(p, len) { return Math.max(60, Math.min(len - 60, Math.round(p / 10) * 10)); }
  function moveSpot(spotId, railId, posMm, silent) {
    var s = spotById(spotId);
    var rail = state.rails.filter(function (r) { return r.id === railId; })[0];
    if (!s || !rail) return false;
    if (!silent) { history.push(snapshot()); future = []; }
    s.railId = railId; s.positionMm = clampPos(posMm, rail.lengthMm);
    if (!silent) saveLocal();
    renderAll();
    return true;
  }
  function rotateSpot(spotId) { var s = spotById(spotId); if (!s) return; history.push(snapshot()); future = []; s.orientation = (s.orientation + 90) % 360; saveLocal(); renderAll(); }
  function deleteSpot(spotId) {
    history.push(snapshot()); future = [];
    state.spots = state.spots.filter(function (s) { return s.id !== spotId; });
    ui.selected = null; saveLocal(); renderAll(); announce('Strahler entfernt.');
  }
  function deleteRail(railId) {
    var idx = state.rails.map(function (r) { return r.id; }).indexOf(railId);
    if (idx < 0) return;
    var removeIds;
    if (idx === 0 || idx === state.rails.length - 1) removeIds = [railId];
    else {
      var after = state.rails.slice(idx);
      if (!window.confirm('Diese Schiene liegt in der Mitte der Anlage. Beim Entfernen werden auch alle ' + (after.length - 1) + ' nachfolgenden Schienen und deren Strahler entfernt. Fortfahren?')) return;
      removeIds = after.map(function (r) { return r.id; });
    }
    history.push(snapshot()); future = [];
    if (removeIds.length === 1) state.rails.splice(idx, 1);
    else state.rails = state.rails.slice(0, idx);
    state.spots = state.spots.filter(function (s) { return removeIds.indexOf(s.railId) < 0; });
    ui.selected = null; saveLocal(); renderAll(); announce('Schiene entfernt.');
  }
  function moveAll(dx, dy, silent) {
    if (!silent) { history.push(snapshot()); future = []; }
    state.rails.forEach(function (r) { r.x += dx; r.y += dy; });
    if (!silent) saveLocal();
    renderAll();
  }
  function setFeedEnd(v) {
    if (!state.rails.length) return;
    history.push(snapshot()); future = [];
    state.feedEnd = v; saveLocal(); renderAll();
    announce('Einspeisung am ' + (v === 'start' ? 'Anfang' : 'Ende') + ' der Anlage.');
  }
  function resetPlanning() {
    if (!window.confirm('Planung zurücksetzen?\n\nAlle Schienen, Strahler und die aktuelle Stückliste werden gelöscht. Das gewählte Schienensystem bleibt erhalten.')) return;
    var keepSys = state.selectedSystem;
    state = freshState();
    state.selectedSystem = keepSys;
    state.currentStep = 'rails';
    history = []; future = []; ui.selected = null; ui.pending = null; closeChooser();
    saveLocal(); goToStep('rails'); fitView();
    announce('Planung zurückgesetzt. Das gewählte System bleibt aktiv.');
  }
  function spotById(id) { return state.spots.filter(function (s) { return s.id === id; })[0]; }
  function snap(v) { return Math.round(v / 50) * 50; }
  function applyTemplate(name) {
    if (state.rails.length || !sys()) return;
    addFirstRail('rail1m', 0, 0);
    if (name === 'gerade') attachRail('end', 0, 'rail1m');
    else if (name === 'l') attachRail('end', 90, 'rail1m');
    else if (name === 'u') { attachRail('end', 90, 'rail1m'); attachRail('end', 180, 'rail1m'); }
    fitView(); announce('Vorlage eingefügt – frei erweiterbar.');
  }

  /* ---------- Schritte ---------- */
  function stepReachable(step) {
    if (step === 'system') return true;
    if (!state.selectedSystem) return false;
    if (step === 'rails') return true;
    return state.rails.length > 0;
  }
  function goToStep(step) {
    if (STEPS.indexOf(step) < 0) return;
    if (!stepReachable(step)) {
      if (!state.selectedSystem) showError('Bitte wählen Sie zuerst ein Schienensystem.');
      else showError('Fügen Sie zunächst mindestens eine Schiene hinzu.');
      return;
    }
    if (step === 'summary' && state.currentStep === 'spots' && !state.spots.length && !ui.confirmNoSpots) {
      ui.confirmNoSpots = true; renderAll(); return;
    }
    ui.confirmNoSpots = false;
    state.currentStep = step;
    ui.pending = null; ui.selected = null; closeChooser();
    saveLocal(); renderAll();
    var labels = { system: 'Schritt 1: Schienensystem auswählen.', rails: 'Schritt 2: Schienenverlauf planen.', spots: 'Schritt 3: Strahler auswählen und platzieren.', summary: 'Schritt 4: Planung prüfen und bestellen.' };
    announce(labels[step]);
    var target = step === 'system' ? q('[data-pltp-view="system"]') : q('.pl-tp-stagecol');
    if (target && target.scrollIntoView) { try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { target.scrollIntoView(); } }
    if (step !== 'system') { applyView(); fitView(); }
  }

  /* ---------- Stückliste ---------- */
  function computeBom() {
    var b = { rail1m: 0, rail2m: 0, mid: 0, l: 0, feeder: state.rails.length ? 1 : 0,
              totalMm: 0, watt: 0, lumen: 0, spotsTotal: 0, priceCents: 0, priceKnown: true,
              has2m: false, unavailable: [], notOrderable: [], spotCounts: {} };
    state.rails.forEach(function (r) {
      b.totalMm += r.lengthMm;
      if (r.key === 'rail2m') { b.rail2m++; b.has2m = true; } else b.rail1m++;
    });
    connectors().forEach(function (c) { if (c.type === 'mid') b.mid++; else b.l++; });
    state.spots.forEach(function (s) {
      b.spotCounts[s.key] = (b.spotCounts[s.key] || 0) + 1;
      b.spotsTotal++;
      var def = spotDef(s.key);
      if (def && typeof def.watt === 'number') b.watt += def.watt;
      if (def && typeof def.lumen === 'number') b.lumen += def.lumen;
    });
    b.lines = bomLines(b);
    b.lines.forEach(function (ln) {
      if (ln.qty <= 0) return;
      if (typeof ln.priceCents === 'number') b.priceCents += ln.priceCents * ln.qty;
      else b.priceKnown = false;
      if (ln.requestOnly) return;
      if (!ln.variantId) b.notOrderable.push(ln.label);
      else if (ln.available === false) b.unavailable.push(ln.label);
    });
    return b;
  }
  function bomLines(b) {
    if (!sys()) return [];
    var S = sys(), lines = [];
    function push(def, qty, group, key) {
      lines.push({ key: key, qty: qty, label: def.label, sku: def.sku || 'FEHLT', group: group,
        priceCents: typeof def.priceCents === 'number' ? def.priceCents : null,
        variantId: def.variantId || null, available: def.available, requestOnly: !!def.requestOnly,
        sub: def.sub || '' });
    }
    push(S.rails.rail1m, b.rail1m, 'verlauf', 'rail1m');
    push(S.rails.rail2m, b.rail2m, 'verlauf', 'rail2m');
    push(S.acc.mid, b.mid, 'verlauf', 'mid');
    push(S.acc.lconn, b.l, 'verlauf', 'lconn');
    push(S.acc.feeder, b.feeder, 'verlauf', 'feeder');
    S.spots.forEach(function (sd) {
      push(sd, b.spotCounts[sd.key] || 0, 'strahler', sd.key);
    });
    return lines;
  }
  function runDescription() {
    return state.rails.map(function (r) { return (r.key === 'rail2m' ? '2 m ' : '1 m ') + DIR_ARROW[r.rotation]; }).join(', ');
  }

  /* ---------- Resume ---------- */
  function tryOfferResume() {
    var raw = null;
    try { raw = localStorage.getItem(STORE_KEY); } catch (e) {}
    if (!raw) return;
    try {
      var saved = JSON.parse(raw);
      if (saved && saved.version === 2 && saved.selectedSystem && (saved.rails.length || saved.spots.length)) {
        els.resume.hidden = false;
      }
    } catch (e) {}
  }
  function resumeSaved() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORE_KEY));
      if (saved && saved.version === 2 && SYSTEMS[saved.selectedSystem]) {
        state = saved;
        if (!stepReachable(state.currentStep)) state.currentStep = state.selectedSystem ? 'rails' : 'system';
        els.resume.hidden = true;
        history = []; future = [];
        renderAll(); goToStep(state.currentStep);
        announce('Gespeicherte Planung geladen.');
        return;
      }
    } catch (e) {}
    els.resume.hidden = true;
  }
  function discardSaved() {
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
    els.resume.hidden = true;
    state = freshState(); history = []; future = [];
    goToStep('system');
    announce('Neue Planung gestartet – bitte System wählen.');
  }

  /* ---------- DOM ---------- */
  var els = {};
  function q(sel) { return rootEl.querySelector(sel); }
  els.svg = q('.pl-tp-svg'); els.stage = q('.pl-tp-stage');
  els.bomVerlauf = q('[data-pltp-bom-verlauf]'); els.bomStrahler = q('[data-pltp-bom-strahler]');
  els.totals = q('.pl-tp-totals'); els.cta = q('.pl-tp-cta'); els.status = q('.pl-tp-status');
  els.error = q('.pl-tp-msg'); els.resume = q('.pl-tp-resume'); els.dialog = q('.pl-tp-dialog');
  els.hint = q('.pl-tp-hint'); els.toast = q('.pl-tp-toast'); els.chooser = q('.pl-tp-chooser');
  els.sysBar = q('.pl-tp-sysbar'); els.feedbar = q('.pl-tp-feedbar');
  els.toolPanel = q('[data-pltp-toolpanel]'); els.bomTitle = q('[data-pltp-bom-title]');

  var SVGNS = 'http://www.w3.org/2000/svg';
  function svgEl(name, attrs, parent) {
    var el = document.createElementNS(SVGNS, name);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(el);
    return el;
  }
  var layers = {};
  ['grid', 'dims', 'cones', 'conn', 'rails', 'caps', 'spots', 'overlay'].forEach(function (n) {
    layers[n] = svgEl('g', { 'class': 'pl-tp-layer-' + n }, els.svg);
  });
  var defs = svgEl('defs', {}, els.svg);
  var pat = svgEl('pattern', { id: 'pl-tp-grid', width: 1000, height: 1000, patternUnits: 'userSpaceOnUse' }, defs);
  svgEl('path', { d: 'M1000 0H0V1000', fill: 'none', stroke: '#e7e3f0', 'stroke-width': 3 }, pat);
  svgEl('path', { d: 'M500 0V1000 M0 500H1000', fill: 'none', stroke: '#f0edf6', 'stroke-width': 2 }, pat);
  svgEl('rect', { fill: 'url(#pl-tp-grid)', x: -60000, y: -60000, width: 120000, height: 120000 }, layers.grid);

  /* ---------- View ---------- */
  var view = { x: -2600, y: -1700, w: 5200 };
  function applyView() { els.svg.setAttribute('viewBox', view.x + ' ' + view.y + ' ' + view.w + ' ' + viewH()); }
  function viewH() { return view.w * (els.svg.clientHeight / Math.max(els.svg.clientWidth, 1)) || view.w * 0.6; }
  function zoom(f) { var cx = view.x + view.w / 2, cy = view.y + viewH() / 2; view.w = Math.min(30000, Math.max(800, view.w * f)); view.x = cx - view.w / 2; view.y = cy - viewH() / 2; applyView(); }
  function fitView() {
    if (!state.rails.length) { view = { x: -2600, y: -1700, w: 5200 }; applyView(); return; }
    var b = bounds(), m = 700;
    var bb = { x: b.x - m, y: b.y - m, w: b.w + 2 * m, h: b.h + 2 * m };
    var w = Math.max(bb.w, 2400), h = Math.max(bb.h, 1500);
    var aspect = els.svg.clientHeight / Math.max(els.svg.clientWidth, 1) || 0.6;
    if (h / w > aspect) w = h / aspect;
    view = { x: bb.x - (w - bb.w) / 2, y: bb.y - (h - bb.h) / 2, w: w };
    applyView();
  }
  function bounds() {
    var xs = [], ys = [];
    state.rails.forEach(function (r) { var e = railEnd(r); xs.push(r.x, e[0]); ys.push(r.y, e[1]); });
    return { x: Math.min.apply(null, xs), y: Math.min.apply(null, ys), w: Math.max.apply(null, xs) - Math.min.apply(null, xs), h: Math.max.apply(null, ys) - Math.min.apply(null, ys) };
  }
  function toMm(evt) {
    var pt = els.svg.createSVGPoint(); pt.x = evt.clientX; pt.y = evt.clientY;
    var m = els.svg.getScreenCTM(); if (!m) return [0, 0];
    var p = pt.matrixTransform(m.inverse()); return [p.x, p.y];
  }

  /* ---------- Rendering ---------- */
  function renderAll() { renderViews(); renderScene(); renderBom(); renderStepper(); renderPanels(); renderToolbarState(); renderSysbar(); }

  function renderViews() {
    var inPlanner = state.currentStep !== 'system';
    q('[data-pltp-view="system"]').hidden = inPlanner;
    q('[data-pltp-view="planner"]').hidden = !inPlanner;
  }
  function renderSysbar() {
    if (!els.sysBar) return;
    if (!sys() || state.currentStep === 'system') { els.sysBar.hidden = true; return; }
    els.sysBar.hidden = false;
    els.sysBar.querySelector('[data-pltp-sysname]').textContent = sys().name;
    // Einspeisungs-Statuszeile
    if (els.feedbar) {
      if (!state.rails.length) { els.feedbar.hidden = true; }
      else {
        els.feedbar.hidden = false;
        els.feedbar.querySelector('[data-pltp-feedlabel]').textContent = 'Einspeisung: ' + (state.feedEnd === 'start' ? 'Anfang der Anlage' : 'Ende der Anlage');
      }
    }
  }
  function renderStepper() {
    Array.prototype.forEach.call(rootEl.querySelectorAll('button[data-pltp-step]'), function (btn) {
      var s = btn.getAttribute('data-pltp-step');
      var num = STEP_NUM[s], cur = STEP_NUM[state.currentStep];
      btn.classList.toggle('is-active', s === state.currentStep);
      btn.classList.toggle('is-done', num < cur);
      btn.disabled = !stepReachable(s);
      btn.setAttribute('aria-current', s === state.currentStep ? 'step' : 'false');
    });
  }
  function renderPanels() {
    ['rails', 'spots', 'summary'].forEach(function (p) {
      var el = q('[data-pltp-panel="' + p + '"]');
      if (el) el.hidden = state.currentStep !== p;
    });
    var tpl = q('.pl-tp-templates'); if (tpl) tpl.hidden = state.rails.length > 0;
    if (state.currentStep === 'spots') renderSpotCards();
    if (state.currentStep === 'rails') renderRailTools();
    if (state.currentStep === 'summary') renderSummaryPanel();
  }
  function renderRailTools() {
    var host = q('[data-pltp-railtools]'); if (!host || !sys()) return;
    var S = sys(), html = '';
    [['rail1m', S.rails.rail1m], ['rail2m', S.rails.rail2m]].forEach(function (pair) {
      var key = pair[0], d = pair[1];
      var flag = d.requestOnly ? '<span class="pl-tp-flag">Nur Projektanfrage · Sperrgut</span>'
        : (d.variantId ? '<span class="pl-tp-flag pl-tp-flag--ok">direkt bestellbar</span>' : '<span class="pl-tp-flag pl-tp-flag--warn">Nur auf Anfrage</span>');
      html += '<div class="pl-tp-tool" data-pltp-railtool="' + key + '" data-pltp-drag="' + key + '" role="button" tabindex="0" aria-label="' + d.label + ' hinzufügen">' +
        '<svg class="pl-tp-tool-rail" viewBox="0 0 200 24" aria-hidden="true"><rect x="4" y="6" width="' + (key === 'rail1m' ? 96 : 192) + '" height="12" rx="2" fill="#ffffff" stroke="#2b2b2e" stroke-width="1.8"/><line x1="7" y1="12" x2="' + (key === 'rail1m' ? 97 : 193) + '" y2="12" stroke="#3a3a3e" stroke-width="1.5"/></svg>' +
        '<div class="pl-tp-tool-row"><h3>' + d.label + '</h3><span class="pl-tp-tool-price">' + (typeof d.priceCents === 'number' ? money(d.priceCents) : 'a. Anfrage') + '</span></div>' +
        flag + '</div>';
    });
    host.innerHTML = html;
  }
  function renderSpotCards() {
    var host = q('[data-pltp-spotcards]'); if (!host || !sys()) return;
    var f = ui.spotFilter;
    var powers = {}, colors = {};
    sys().spots.forEach(function (s) { powers[s.powerKey] = s.powerLabel; colors[s.color] = s.colorLabel; });
    var fh = '<div class="pl-tp-filterrow" role="group" aria-label="Leistung filtern"><span>Ausführung:</span>';
    fh += '<button type="button" class="pl-tp-chip' + (!f.power ? ' is-on' : '') + '" data-pltp-filter-power="">Alle</button>';
    Object.keys(powers).forEach(function (k) { fh += '<button type="button" class="pl-tp-chip' + (f.power === k ? ' is-on' : '') + '" data-pltp-filter-power="' + k + '">' + powers[k] + '</button>'; });
    fh += '</div><div class="pl-tp-filterrow" role="group" aria-label="Farbe filtern"><span>Farbe:</span>';
    fh += '<button type="button" class="pl-tp-chip' + (!f.color ? ' is-on' : '') + '" data-pltp-filter-color="">Alle</button>';
    Object.keys(colors).forEach(function (k) { fh += '<button type="button" class="pl-tp-chip' + (f.color === k ? ' is-on' : '') + '" data-pltp-filter-color="' + k + '">' + colors[k] + '</button>'; });
    fh += '</div>';
    var cards = '';
    sys().spots.forEach(function (s) {
      if (f.power && s.powerKey !== f.power) return;
      if (f.color && s.color !== f.color) return;
      var facts = s.facts.map(function (x) { return '<li>' + x + '</li>'; }).join('');
      var avail = s.variantId ? (s.available ? '<span class="pl-tp-flag pl-tp-flag--ok">verfügbar</span>' : '<span class="pl-tp-flag pl-tp-flag--warn">derzeit nicht ab Lager</span>') : '<span class="pl-tp-flag pl-tp-flag--warn">Nur auf Anfrage</span>';
      cards += '<div class="pl-tp-spotcard' + (ui.pending === s.key ? ' is-on' : '') + '" data-pltp-spotcard="' + s.key + '" data-pltp-drag="' + s.key + '">' +
        (s.img ? '<img src="' + s.img + '" alt="' + s.label + '" loading="lazy" width="74" height="74">' : '') +
        '<h3>' + s.label + '</h3><p class="pl-tp-tool-sub">' + s.systemLabel + ' · ' + s.colorLabel + ' · ' + s.sku + '</p>' +
        '<ul>' + facts + '</ul>' + avail +
        '<span class="pl-tp-tool-price">' + (typeof s.priceCents === 'number' ? money(s.priceCents) : '–') + '</span>' +
        '<button type="button" class="pl-tp-btn pl-tp-spotbtn" data-pltp-spotpick="' + s.key + '">Auf Schiene platzieren</button></div>';
    });
    host.innerHTML = fh + '<div class="pl-tp-spotcardgrid">' + (cards || '<p class="pl-tp-toolhint">Keine Strahler für diese Filterkombination.</p>') + '</div>';
  }
  function renderSummaryPanel() {
    var host = q('[data-pltp-summaryinfo]'); if (!host || !sys()) return;
    host.innerHTML = '<p class="pl-tp-sysline"><strong>' + sys().name + '</strong></p>' +
      '<p class="pl-tp-toolhint">Prüfen Sie rechts Ihre Stückliste. Über die Zeichnung können Sie weiterhin Elemente auswählen, verschieben oder löschen.</p>' +
      (sys().orderable === false ? '<p class="pl-tp-softnote">Die Schienen und das Zubehör des 1-Phasen-Systems sind aktuell nur über eine Projektanfrage erhältlich.</p>' : '');
  }

  function renderScene() {
    ['dims', 'cones', 'conn', 'rails', 'caps', 'spots', 'overlay'].forEach(function (n) { while (layers[n].firstChild) layers[n].removeChild(layers[n].firstChild); });
    if (state.currentStep === 'system') return;
    var RW = railW();

    state.rails.forEach(function (r) {
      var e = railEnd(r);
      var g = svgEl('g', { 'class': 'pl-tp-rail' + (ui.selected === r.id ? ' is-selected' : ''), 'data-pltp-rail': r.id, 'data-pltp-railkey': r.key }, layers.rails);
      var horiz = r.rotation === 0 || r.rotation === 180;
      var x = Math.min(r.x, e[0]), y = Math.min(r.y, e[1]);
      svgEl('rect', { x: x - (horiz ? 0 : RW / 2), y: y - (horiz ? RW / 2 : 0), width: horiz ? r.lengthMm : RW, height: horiz ? RW : r.lengthMm, rx: 5, 'class': 'pl-tp-rail-body' }, g);
      [-RW / 4, RW / 4].forEach(function (off) {
        svgEl('line', { x1: r.x + (horiz ? 0 : off), y1: r.y + (horiz ? off : 0), x2: e[0] + (horiz ? 0 : off), y2: e[1] + (horiz ? off : 0), 'class': 'pl-tp-rail-profile' }, g);
      });
      svgEl('line', { x1: r.x, y1: r.y, x2: e[0], y2: e[1], 'class': 'pl-tp-rail-slot' }, g);
      var mx = (r.x + e[0]) / 2, my = (r.y + e[1]) / 2;
      var t = svgEl('text', { x: horiz ? mx : mx + 70, y: horiz ? my + 92 : my, 'text-anchor': horiz ? 'middle' : 'start', 'class': 'pl-tp-rail-label' }, g);
      t.textContent = r.key === 'rail2m' ? '2 m' : '1 m';
    });

    connectors().forEach(function (c) {
      if (c.type === 'mid') {
        var horiz = c.dirA === 0 || c.dirA === 180;
        svgEl('rect', { x: c.at[0] - (horiz ? 32 : 23), y: c.at[1] - (horiz ? 23 : 32), width: horiz ? 64 : 46, height: horiz ? 46 : 64, rx: 7, 'class': 'pl-tp-conn pl-tp-conn-mid' }, layers.conn);
      } else {
        svgEl('rect', { x: c.at[0] - 42, y: c.at[1] - 42, width: 84, height: 84, rx: 9, 'class': 'pl-tp-conn pl-tp-conn-l' }, layers.conn);
      }
    });

    if (state.rails.length) {
      var sPt = chainStart(), ePt = chainEnd();
      var feedPt = state.feedEnd === 'start' ? sPt : ePt;
      var capPt = state.feedEnd === 'start' ? ePt : sPt;
      var feedDir = state.feedEnd === 'start' ? reverseDir(state.rails[0].rotation) : state.rails[state.rails.length - 1].rotation;
      var capDir = state.feedEnd === 'start' ? state.rails[state.rails.length - 1].rotation : reverseDir(state.rails[0].rotation);
      drawFeeder(feedPt, feedDir, state.feedEnd); drawCap(capPt, capDir);
    }

    state.spots.forEach(function (s) {
      var rail = state.rails.filter(function (r) { return r.id === s.railId; })[0];
      var def = spotDef(s.key);
      if (!rail || !def) return;
      var d = DIRS[rail.rotation];
      var cx = rail.x + d[0] * s.positionMm, cy = rail.y + d[1] * s.positionMm;
      var od = DIRS[s.orientation];
      if (def.beam) {
        var spread = def.beam >= 35 ? 0.42 : 0.26, len = def.beam >= 35 ? 300 : 380;
        svgEl('path', { d: 'M' + cx + ' ' + cy + ' L' + (cx + od[0] * len - od[1] * len * spread) + ' ' + (cy + od[1] * len - od[0] * len * spread) + ' L' + (cx + od[0] * len + od[1] * len * spread) + ' ' + (cy + od[1] * len + od[0] * len * spread) + ' Z', 'class': 'pl-tp-cone' }, layers.cones);
      }
      var g = svgEl('g', { 'class': 'pl-tp-spot pl-tp-spot--' + def.color + (ui.selected === s.id ? ' is-selected' : ''), 'data-pltp-spot': s.id, tabindex: -1 }, layers.spots);
      svgEl('circle', { cx: cx, cy: cy, r: def.radiusMm + 14, 'class': 'pl-tp-spot-ring' }, g);
      svgEl('circle', { cx: cx, cy: cy, r: def.radiusMm, 'class': 'pl-tp-spot-body' }, g);
      svgEl('circle', { cx: cx, cy: cy, r: Math.max(10, def.radiusMm - 13), 'class': 'pl-tp-spot-lens' }, g);
      svgEl('line', { x1: cx, y1: cy, x2: cx + od[0] * (def.radiusMm + 24), y2: cy + od[1] * (def.radiusMm + 24), 'class': 'pl-tp-spot-orient' }, g);
      var t = svgEl('text', { x: cx, y: cy + def.radiusMm + 50, 'text-anchor': 'middle', 'class': 'pl-tp-spot-label' }, g);
      t.textContent = def.shortLabel;
    });

    if (state.rails.length) {
      [['start', chainStart()], ['end', chainEnd()]].forEach(function (pair) {
        var active = state.currentStep === 'rails';
        var g = svgEl('g', { 'class': 'pl-tp-end' + (active ? ' is-active' : ''), 'data-pltp-end': pair[0] }, layers.overlay);
        svgEl('circle', { cx: pair[1][0], cy: pair[1][1], r: 70, 'class': 'pl-tp-end-zone' }, g);
        svgEl('circle', { cx: pair[1][0], cy: pair[1][1], r: 46, 'class': 'pl-tp-end-dot' }, g);
        var t = svgEl('text', { x: pair[1][0], y: pair[1][1] + 15, 'text-anchor': 'middle', 'class': 'pl-tp-end-plus' }, g);
        t.textContent = state.currentStep === 'rails' ? '+' : '⚡';
      });
    }

    if (ui.hover) drawGhost(ui.hover);

    if (state.rails.length) {
      var b = bounds();
      if (b.w > 0) drawDim(b.x, b.y - 240, b.x + b.w, b.y - 240, fmtM(b.w), false);
      if (b.h > 0) drawDim(b.x - 240, b.y, b.x - 240, b.y + b.h, fmtM(b.h), true);
    }
  }
  function drawGhost(h) {
    if (h.kind === 'rail') {
      var RW = railW();
      var horiz = h.dir === 0 || h.dir === 180;
      var g = svgEl('g', { 'class': 'pl-tp-ghost' }, layers.overlay);
      svgEl('rect', { x: Math.min(h.s[0], h.e[0]) - (horiz ? 0 : RW / 2), y: Math.min(h.s[1], h.e[1]) - (horiz ? RW / 2 : 0), width: horiz ? h.len : RW, height: horiz ? RW : h.len, rx: 5, 'class': 'pl-tp-ghost-body' }, g);
      if (h.connLabel) {
        var badge = svgEl('g', { 'class': 'pl-tp-ghost-badge' }, g);
        svgEl('rect', { x: h.j[0] - 320, y: h.j[1] - 168, width: 640, height: 80, rx: 40 }, badge);
        var t = svgEl('text', { x: h.j[0], y: h.j[1] - 112, 'text-anchor': 'middle' }, badge);
        t.textContent = '+ ' + h.connLabel;
      }
    } else if (h.kind === 'spot') {
      svgEl('circle', { cx: h.p[0], cy: h.p[1], r: h.r || 30, 'class': 'pl-tp-ghost-spot' }, svgEl('g', { 'class': 'pl-tp-ghost' }, layers.overlay));
    }
  }
  function fmtM(mm) { return (mm / 1000).toLocaleString('de-DE', { maximumFractionDigits: 2 }) + ' m'; }
  function drawDim(x1, y1, x2, y2, label, vert) {
    var g = svgEl('g', { 'class': 'pl-tp-dim' }, layers.dims);
    svgEl('line', { x1: x1, y1: y1, x2: x2, y2: y2 }, g);
    var t = svgEl('text', { x: (x1 + x2) / 2, y: (y1 + y2) / 2 - 22, 'text-anchor': 'middle' }, g);
    if (vert) t.setAttribute('transform', 'rotate(-90 ' + ((x1 + x2) / 2 - 22) + ' ' + ((y1 + y2) / 2) + ')');
    t.textContent = label;
  }
  function drawFeeder(pt, outDir, endName) {
    var d = DIRS[outDir];
    var g = svgEl('g', { 'class': 'pl-tp-feeder', 'data-pltp-feeder': endName, tabindex: -1, role: 'button', 'aria-label': 'Einspeisepunkt' }, layers.caps);
    var horiz = outDir === 0 || outDir === 180, len = 100;
    svgEl('rect', { x: Math.min(pt[0], pt[0] + d[0] * len) - (horiz ? 0 : 22), y: Math.min(pt[1], pt[1] + d[1] * len) - (horiz ? 22 : 0), width: horiz ? len : 44, height: horiz ? 44 : len, rx: 7 }, g);
    var cx = pt[0] + d[0] * (len + 58), cy = pt[1] + d[1] * (len + 58);
    svgEl('circle', { cx: cx, cy: cy, r: 44, 'class': 'pl-tp-feeder-icon' }, g);
    svgEl('path', { d: 'M' + (cx + 8) + ' ' + (cy - 25) + ' l-21 28 h15 l-10 22 25 -30 h-15 z', 'class': 'pl-tp-feeder-bolt' }, g);
    var t = svgEl('text', { x: cx, y: cy + 82, 'text-anchor': 'middle', 'class': 'pl-tp-cap-label' }, g);
    t.textContent = 'Einspeisung';
  }
  function drawCap(pt, outDir) {
    var d = DIRS[outDir], g = svgEl('g', { 'class': 'pl-tp-cap' }, layers.caps);
    var horiz = outDir === 0 || outDir === 180;
    svgEl('rect', { x: Math.min(pt[0], pt[0] + d[0] * 34) - (horiz ? 0 : 20), y: Math.min(pt[1], pt[1] + d[1] * 34) - (horiz ? 20 : 0), width: horiz ? 34 : 40, height: horiz ? 40 : 34, rx: 6 }, g);
    var t = svgEl('text', { x: pt[0] + d[0] * 52, y: pt[1] + d[1] * 52 + (horiz ? -36 : 10), 'text-anchor': 'middle', 'class': 'pl-tp-cap-label' }, g);
    t.textContent = 'Endabschluss';
  }

  /* ---------- Stückliste rendern ---------- */
  function money(cents) { return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  function bomRow(ln) {
    var price = typeof ln.priceCents === 'number' ? money(ln.priceCents * ln.qty) : 'a. Anfrage';
    var pm = ln.group === 'strahler' ? '<span class="pl-tp-qtybtns"><button type="button" data-pltp-qminus="' + ln.key + '" aria-label="Einen ' + ln.label + ' entfernen">−</button><button type="button" data-pltp-qplus="' + ln.key + '" aria-label="Einen ' + ln.label + ' hinzufügen">+</button></span>' : '';
    var note = ln.requestOnly ? '<span class="pl-tp-bom-flag">Projektanfrage</span>' : (!ln.variantId ? '<span class="pl-tp-bom-flag">nur auf Anfrage</span>' : '');
    var sub = ln.sub ? '<span class="pl-tp-bom-sub">' + ln.sub + '</span>' : '';
    return '<tr class="pl-tp-bom-row" data-pltp-bomkey="' + ln.key + '" tabindex="0"><td class="pl-tp-bom-qty">' + ln.qty + '×</td><td>' + ln.label + '<span class="pl-tp-bom-sub">' + ln.sku + '</span>' + sub + note + '</td><td class="pl-tp-bom-price">' + price + pm + '</td></tr>';
  }
  function renderBom() {
    var b = computeBom();
    if (els.bomTitle) els.bomTitle.textContent = sys() ? sys().name : '';
    var v = '', s = '';
    b.lines.forEach(function (ln) {
      if (ln.qty <= 0) return;
      if (ln.group === 'verlauf') v += bomRow(ln); else s += bomRow(ln);
    });
    els.bomVerlauf.innerHTML = v || '<tr><td colspan="3" class="pl-tp-bom-empty">Noch keine Schienen geplant.</td></tr>';
    els.bomStrahler.innerHTML = s || '<tr><td colspan="3" class="pl-tp-bom-empty">Noch keine Strahler platziert.</td></tr>';
    var totals = '';
    totals += tot('Schienenlänge', fmtM(b.totalMm));
    totals += tot('Strahler', String(b.spotsTotal));
    totals += tot('Gesamtleistung (LED)', b.watt + ' W');
    totals += tot('Rechn. Lichtstrom (LED)', b.lumen.toLocaleString('de-DE') + ' lm');
    totals += tot('Materialwert', b.priceKnown ? money(b.priceCents) : 'auf Anfrage', true);
    els.totals.innerHTML = totals;
    renderCta(b);
  }
  function tot(k, v2, strong) { return '<div class="pl-tp-tot' + (strong ? ' pl-tp-tot--strong' : '') + '"><span>' + k + '</span><span>' + v2 + '</span></div>'; }

  function renderCta(b) {
    var html = '';
    if (state.currentStep === 'system' || !sys()) { els.cta.innerHTML = ''; return; }
    var orderBlocked = b.has2m || b.notOrderable.length > 0 || b.unavailable.length > 0 || sys().orderable === false;
    if (b.has2m) html += '<p class="pl-tp-softnote">Ihre Planung enthält eine 2-m-Schiene. Aufgrund des Sperrgutversands erhalten Sie dafür ein individuelles Versand- und Projektangebot.</p>';
    if (sys().orderable === false) html += '<p class="pl-tp-softnote">Schienen und Zubehör des 1-Phasen-Systems sind derzeit nur über eine Projektanfrage erhältlich.</p>';
    else if (b.notOrderable.length) html += '<p class="pl-tp-softnote">Nur auf Anfrage: ' + b.notOrderable.join(', ') + '.</p>';
    else if (b.unavailable.length) html += '<p class="pl-tp-softnote">Derzeit nicht ab Lager: ' + b.unavailable.join(', ') + '.</p>';

    if (state.currentStep === 'rails') {
      html += '<button type="button" class="pl-tp-btn pl-tp-btn--primary" data-pltp-action="next-spots"' + (state.rails.length ? '' : ' disabled') + '>Weiter: Strahler auswählen</button>';
      if (!state.rails.length) html += '<p class="pl-tp-smallprint">Fügen Sie zunächst mindestens eine Schiene hinzu.</p>';
      html += '<button type="button" class="pl-tp-btn pl-tp-linkbtn" data-pltp-action="change-system">System wechseln</button>';
    } else if (state.currentStep === 'spots') {
      if (ui.confirmNoSpots) {
        html += '<p class="pl-tp-softnote">In Ihrer Planung wurden noch keine Strahler platziert.</p>';
        html += '<button type="button" class="pl-tp-btn" data-pltp-action="stay-spots">Strahler hinzufügen</button> ';
        html += '<button type="button" class="pl-tp-btn pl-tp-btn--primary" data-pltp-action="force-summary">Trotzdem zur Zusammenfassung</button>';
      } else {
        html += '<button type="button" class="pl-tp-btn pl-tp-btn--primary" data-pltp-action="next-summary">Weiter: Planung prüfen</button>';
      }
      html += '<button type="button" class="pl-tp-btn pl-tp-linkbtn" data-pltp-action="back-rails">Zurück zum Schienenverlauf</button>';
    } else if (state.currentStep === 'summary') {
      if (!state.rails.length) {
        html += '<button type="button" class="pl-tp-btn pl-tp-btn--primary" disabled>Plan direkt bestellen</button>';
      } else if (orderBlocked) {
        html += '<button type="button" class="pl-tp-btn pl-tp-btn--primary" data-pltp-action="request">Projektangebot anfragen</button>';
      } else {
        html += '<button type="button" class="pl-tp-btn pl-tp-btn--primary" data-pltp-action="cart">Plan direkt bestellen</button>';
      }
      html += '<button type="button" class="pl-tp-btn pl-tp-linkbtn" data-pltp-action="back-spots">Zurück zur Strahlerauswahl</button>';
      html += '<p class="pl-tp-smallprint">Die angezeigte Gesamtleistung dient der Übersicht. Elektrischer Anschluss und Auslegung der Anlage müssen fachgerecht erfolgen.</p>';
      html += '<p class="pl-tp-smallprint">Der rechnerische Gesamtlichtstrom berücksichtigt nur fest integrierte LED-Strahler – GU10-Leuchtmittel sind nicht enthalten – sowie keine Raumgeometrie, Reflexionen oder Montagehöhe.</p>';
    }
    els.cta.innerHTML = html;
  }

  function renderToolbarState() {
    var sel = ui.selected;
    var isSpot = sel && sel.indexOf('spot') === 0;
    q('[data-pltp-action="delete-selected"]').disabled = !sel;
    q('[data-pltp-action="rotate-spot"]').disabled = !isSpot;
    q('[data-pltp-action="undo"]').disabled = !history.length;
    q('[data-pltp-action="redo"]').disabled = !future.length;
    q('[data-pltp-action="toggle-feed"]').disabled = !state.rails.length;
    var hint = '';
    if (state.currentStep === 'rails') {
      if (!state.rails.length) hint = 'Starten Sie mit einer Vorlage oder fügen Sie links Ihre erste Schiene hinzu.';
      else if (ui.pending && railDef(ui.pending)) hint = 'Anschlussfläche (+) am gewünschten Ende antippen.';
    } else if (state.currentStep === 'spots' && ui.pending && spotDef(ui.pending)) {
      hint = 'Tippen Sie auf eine Schiene, um den Strahler zu platzieren.';
    }
    els.hint.textContent = hint; els.hint.hidden = !hint;
  }

  function highlightPart(key) {
    var sel;
    if (key === 'rail1m' || key === 'rail2m') sel = '[data-pltp-railkey="' + key + '"] .pl-tp-rail-body';
    else if (key === 'mid') sel = '.pl-tp-conn-mid';
    else if (key === 'lconn') sel = '.pl-tp-conn-l';
    else if (key === 'feeder') sel = '.pl-tp-feeder rect, .pl-tp-feeder-icon, .pl-tp-cap rect';
    else sel = null;
    var nodes = [];
    if (sel) nodes = els.svg.querySelectorAll(sel);
    else {
      state.spots.forEach(function (s) {
        if (s.key === key) {
          var el = els.svg.querySelector('[data-pltp-spot="' + s.id + '"] .pl-tp-spot-body');
          if (el) nodes = Array.prototype.concat.call([], Array.prototype.slice.call(nodes), [el]);
        }
      });
    }
    Array.prototype.forEach.call(nodes, function (el) {
      el.classList.remove('is-flash'); void el.getBBox; el.classList.add('is-flash');
      setTimeout(function () { el.classList.remove('is-flash'); }, 1600);
    });
  }
  function spotMinus(key) {
    for (var i = state.spots.length - 1; i >= 0; i--) {
      if (state.spots[i].key === key) { deleteSpot(state.spots[i].id); return; }
    }
  }
  function spotPlus(key) {
    if (!state.rails.length) return;
    var best = null;
    state.rails.forEach(function (r) {
      var n = state.spots.filter(function (s) { return s.railId === r.id; }).length;
      var score = r.lengthMm / (n + 1);
      if (!best || score > best.score) best = { r: r, score: score, n: n };
    });
    addSpot(key, best.r.id, ((best.n % 3) + 1) * best.r.lengthMm / 4);
  }

  /* ---------- Meldungen ---------- */
  var msgTimer, toastTimer;
  function showError(msg) {
    els.error.textContent = msg; els.error.hidden = false;
    clearTimeout(msgTimer); msgTimer = setTimeout(function () { els.error.hidden = true; }, 5000);
    announce(msg);
  }
  function toast(msg) {
    els.toast.textContent = msg; els.toast.hidden = false; els.toast.classList.add('is-in');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { els.toast.classList.remove('is-in'); els.toast.hidden = true; }, 2600);
  }
  function announce(msg) { els.status.textContent = msg; }

  /* ---------- Anschluss-Popover ---------- */
  function openChooser(endType) {
    ui.pendingEnd = endType;
    var pt = endType === 'end' ? chainEnd() : chainStart();
    var ctm = els.svg.getScreenCTM();
    var sp = els.svg.createSVGPoint(); sp.x = pt[0]; sp.y = pt[1];
    var scr = sp.matrixTransform(ctm);
    var stageRect = els.stage.getBoundingClientRect();
    var relX = scr.x - stageRect.left, relY = scr.y - stageRect.top;
    var html = '<p class="pl-tp-chooser-title">Welche Schiene möchten Sie anschließen?</p><div class="pl-tp-chooser-parts">';
    ['rail1m', 'rail2m'].forEach(function (k) {
      var d = railDef(k);
      html += '<button type="button" class="pl-tp-chip' + (ui.railChoice === k ? ' is-on' : '') + '" data-pltp-choosepart="' + k + '">' + (k === 'rail1m' ? '1 m' : '2 m') + '<small>' + (d.requestOnly || !d.variantId ? 'Projektversand' : 'direkt bestellbar') + '</small></button>';
    });
    html += '</div><p class="pl-tp-chooser-title">In welche Richtung?</p><div class="pl-tp-chooser-dirs">';
    var rels = validRel(endType, railDef(ui.railChoice).lengthMm);
    [['gerade', 'Gerade'], ['links', 'Links'], ['rechts', 'Rechts']].forEach(function (pair) {
      html += '<button type="button" class="pl-tp-chip" data-pltp-choosedir="' + pair[0] + '"' + (rels.indexOf(pair[0]) > -1 ? '' : ' disabled') + '>' + pair[1] + '</button>';
    });
    html += '</div><button type="button" class="pl-tp-chip pl-tp-chooser-feed" data-pltp-choosefeed="' + endType + '">⚡ Hier einspeisen</button>';
    html += '<button type="button" class="pl-tp-chooser-close" data-pltp-chooserclose aria-label="Schließen">×</button>';
    els.chooser.innerHTML = html;
    els.chooser.hidden = false;
    var cw = 250;
    els.chooser.style.left = Math.max(8, Math.min(stageRect.width - cw - 8, relX - cw / 2)) + 'px';
    els.chooser.style.top = Math.max(8, Math.min(stageRect.height - 230, relY + 24)) + 'px';
    renderScene();
  }
  function closeChooser() { ui.pendingEnd = null; if (els.chooser) { els.chooser.hidden = true; els.chooser.innerHTML = ''; } }

  /* ---------- Event-Delegation (kollisionssicher) ---------- */
  function hit(ev, sel) {
    var t = ev.target;
    if (!t || !t.closest) return null;
    var el = t.closest(sel);
    return el && rootEl.contains(el) ? el : null;
  }

  rootEl.addEventListener('click', function (ev) {
    var el;
    if ((el = hit(ev, 'button[data-pltp-system]'))) { selectSystem(el.getAttribute('data-pltp-system')); return; }
    if ((el = hit(ev, 'button[data-pltp-step]'))) { if (!el.disabled) goToStep(el.getAttribute('data-pltp-step')); return; }
    if ((el = hit(ev, '[data-pltp-railtool]'))) {
      var key = el.getAttribute('data-pltp-railtool');
      ui.railChoice = key;
      if (!state.rails.length) { addFirstRail(key, 0, 0); fitView(); }
      else { ui.pending = key; renderAll(); announce('Anschlussende (+) auf der Fläche wählen.'); }
      return;
    }
    if ((el = hit(ev, 'button[data-pltp-template]'))) { applyTemplate(el.getAttribute('data-pltp-template')); return; }
    if ((el = hit(ev, 'button[data-pltp-spotpick]'))) {
      ui.pending = el.getAttribute('data-pltp-spotpick');
      renderAll(); announce(spotDef(ui.pending).label + ' gewählt – jetzt auf eine Schiene tippen.');
      return;
    }
    if ((el = hit(ev, 'button[data-pltp-filter-power], button[data-pltp-filter-color]'))) {
      if (el.hasAttribute('data-pltp-filter-power')) ui.spotFilter.power = el.getAttribute('data-pltp-filter-power') || null;
      else ui.spotFilter.color = el.getAttribute('data-pltp-filter-color') || null;
      renderPanels(); return;
    }
    if ((el = hit(ev, '[data-pltp-choosepart]'))) { ui.railChoice = el.getAttribute('data-pltp-choosepart'); openChooser(ui.pendingEnd); return; }
    if ((el = hit(ev, '[data-pltp-choosedir]'))) {
      attachRail(ui.pendingEnd, relToStored(ui.pendingEnd, el.getAttribute('data-pltp-choosedir')), ui.railChoice);
      closeChooser(); ui.pending = null; renderAll(); fitView(); return;
    }
    if ((el = hit(ev, '[data-pltp-choosefeed]'))) { setFeedEnd(el.getAttribute('data-pltp-choosefeed')); closeChooser(); return; }
    if (hit(ev, '[data-pltp-chooserclose]')) { closeChooser(); return; }
    if ((el = hit(ev, '.pl-tp-bom-row')) && !hit(ev, 'button')) { highlightPart(el.getAttribute('data-pltp-bomkey')); return; }
    if ((el = hit(ev, 'button[data-pltp-qminus]'))) { spotMinus(el.getAttribute('data-pltp-qminus')); return; }
    if ((el = hit(ev, 'button[data-pltp-qplus]'))) { spotPlus(el.getAttribute('data-pltp-qplus')); return; }
    if (hit(ev, '[data-pltp-resume-yes]')) { resumeSaved(); return; }
    if (hit(ev, '[data-pltp-resume-no]')) { discardSaved(); return; }
    if ((el = hit(ev, '[data-pltp-action]'))) {
      switch (el.getAttribute('data-pltp-action')) {
        case 'undo': undo(); break;
        case 'redo': redo(); break;
        case 'reset': resetPlanning(); break;
        case 'zoom-in': zoom(0.8); break;
        case 'zoom-out': zoom(1.25); break;
        case 'fit': fitView(); break;
        case 'toggle-feed': setFeedEnd(state.feedEnd === 'start' ? 'end' : 'start'); break;
        case 'delete-selected':
          if (!ui.selected) break;
          if (ui.selected.indexOf('spot') === 0) deleteSpot(ui.selected); else deleteRail(ui.selected);
          break;
        case 'rotate-spot': if (ui.selected) rotateSpot(ui.selected); break;
        case 'change-system': changeSystem(); break;
        case 'next-spots': goToStep('spots'); break;
        case 'next-summary': goToStep('summary'); break;
        case 'force-summary': goToStep('summary'); break;
        case 'stay-spots': ui.confirmNoSpots = false; renderAll(); break;
        case 'back-rails': goToStep('rails'); break;
        case 'back-spots': goToStep('spots'); break;
        case 'cart': addToCart(); break;
        case 'request': openRequest(); break;
        case 'dialog-close': if (els.dialog.close) els.dialog.close(); else els.dialog.removeAttribute('open'); break;
        case 'mob-rail': goToStep('rails'); break;
        case 'mob-spot': goToStep('spots'); break;
        case 'mob-summary': { var d0 = q('.pl-tp-summarycol details'); if (d0) d0.open = true; q('.pl-tp-summarycol').scrollIntoView({ behavior: 'smooth' }); break; }
      }
      return;
    }
  });
  rootEl.addEventListener('keydown', function (ev) {
    var row = hit(ev, '.pl-tp-bom-row');
    if (row && (ev.key === 'Enter' || ev.key === ' ')) { ev.preventDefault(); highlightPart(row.getAttribute('data-pltp-bomkey')); }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') { ui.pending = null; closeChooser(); renderAll(); }
    var ae = document.activeElement;
    var typing = ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA');
    if ((ev.key === 'Delete' || ev.key === 'Backspace') && ui.selected && !typing) {
      ev.preventDefault();
      if (ui.selected.indexOf('spot') === 0) deleteSpot(ui.selected); else deleteRail(ui.selected);
    }
    if (ev.key === 'z' && (ev.metaKey || ev.ctrlKey) && !typing) { ev.preventDefault(); if (ev.shiftKey) redo(); else undo(); }
  });

  /* ---------- Drag & Drop (Zusatzfunktion) ---------- */
  rootEl.addEventListener('pointerdown', function (ev) {
    var item = hit(ev, '[data-pltp-drag]');
    if (!item || hit(ev, 'button')) return;
    var key = item.getAttribute('data-pltp-drag');
    var isRail = !!railDef(key);
    if (!isRail && !spotDef(key)) return;
    ev.preventDefault();
    var ghost = document.createElement('div');
    ghost.className = 'pl-tp-drag-ghost';
    ghost.textContent = isRail ? railDef(key).label : spotDef(key).label;
    document.body.appendChild(ghost);
    function inside(e) { var r = els.svg.getBoundingClientRect(); return e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom; }
    function mv(e) {
      ghost.style.left = e.clientX + 'px'; ghost.style.top = e.clientY + 'px';
      if (!inside(e)) { ui.hover = null; renderScene(); return; }
      var mm = toMm(e);
      if (isRail) {
        if (!state.rails.length) { ui.hover = null; renderScene(); return; }
        var best = nearestEndCandidate(mm, railDef(key).lengthMm);
        ui.hover = best ? best.hover : null;
      } else {
        var hitR = nearestRail(mm, 220);
        ui.hover = hitR ? { kind: 'spot', p: railPoint(hitR.rail, hitR.posMm), r: spotDef(key).radiusMm } : null;
      }
      renderScene();
    }
    mv(ev);
    function up(e) {
      document.removeEventListener('pointermove', mv); document.removeEventListener('pointerup', up);
      ghost.remove();
      var was = ui.hover; ui.hover = null;
      if (!inside(e)) { renderScene(); return; }
      var mm = toMm(e);
      if (isRail) {
        if (!state.rails.length) { addFirstRail(key, mm[0], mm[1]); fitView(); return; }
        var best = nearestEndCandidate(mm, railDef(key).lengthMm);
        if (!best) { showError('Bitte an einem freien Anschlussende (+) ablegen.'); renderScene(); return; }
        attachRail(best.endType, best.stored, key); fitView();
      } else {
        if (state.currentStep === 'rails') goToStep('spots');
        var hitR = nearestRail(mm, 220);
        if (!hitR) { showError('Strahler können nur auf Schienen platziert werden.'); renderScene(); return; }
        addSpot(key, hitR.rail.id, hitR.posMm);
      }
    }
    document.addEventListener('pointermove', mv); document.addEventListener('pointerup', up);
  });
  function railPoint(rail, pos) { var d = DIRS[rail.rotation]; return [rail.x + d[0] * pos, rail.y + d[1] * pos]; }
  function nearestEndCandidate(mm, len) {
    var cands = [];
    ['start', 'end'].forEach(function (endType) {
      var j = endType === 'end' ? chainEnd() : chainStart();
      validRel(endType, len).forEach(function (rel) {
        var stored = relToStored(endType, rel);
        var s, e;
        if (endType === 'end') { s = j.slice(); e = [s[0] + DIRS[stored][0] * len, s[1] + DIRS[stored][1] * len]; }
        else { e = j.slice(); s = [e[0] - DIRS[stored][0] * len, e[1] - DIRS[stored][1] * len]; }
        var midp = [(s[0] + e[0]) / 2, (s[1] + e[1]) / 2];
        var neighborRot = endType === 'end' ? state.rails[state.rails.length - 1].rotation : state.rails[0].rotation;
        cands.push({ d: Math.hypot(mm[0] - midp[0], mm[1] - midp[1]), endType: endType, stored: stored,
          hover: { kind: 'rail', s: s, e: e, dir: stored, len: len, j: j, connLabel: stored === neighborRot ? 'Mittelverbinder' : 'L-Verbinder' } });
      });
    });
    if (!cands.length) return null;
    cands.sort(function (a, b) { return a.d - b.d; });
    return cands[0].d < 1600 ? cands[0] : null;
  }
  function nearestRail(mm, maxDist) {
    var best = null;
    state.rails.forEach(function (r) {
      var d = DIRS[r.rotation];
      var t = Math.max(0, Math.min(r.lengthMm, (mm[0] - r.x) * d[0] + (mm[1] - r.y) * d[1]));
      var dd = Math.hypot(mm[0] - (r.x + d[0] * t), mm[1] - (r.y + d[1] * t));
      if (dd <= maxDist && (!best || dd < best.dist)) best = { rail: r, posMm: t, dist: dd };
    });
    return best;
  }

  /* ---------- SVG-Interaktion ---------- */
  var drag = null;
  els.svg.addEventListener('pointerdown', function (ev) {
    if (state.currentStep === 'system') return;
    var mm = toMm(ev);
    var endEl = hit(ev, '[data-pltp-end]');
    if (endEl && state.rails.length) {
      var endType = endEl.getAttribute('data-pltp-end');
      if (state.currentStep === 'rails') { openChooser(endType); return; }
      setFeedEnd(endType); return; // in Schritt 3/4: Endpunkt-Klick = Einspeisepunkt
    }
    var feederEl = hit(ev, '[data-pltp-feeder]');
    if (feederEl) { setFeedEnd(state.feedEnd === 'start' ? 'end' : 'start'); return; }
    closeChooser();
    var spotEl = hit(ev, '[data-pltp-spot]');
    if (spotEl) {
      var sid = spotEl.getAttribute('data-pltp-spot');
      ui.selected = sid; renderAll();
      drag = { type: 'spot', id: sid, orig: clone(spotById(sid)), moved: false };
      try { els.svg.setPointerCapture(ev.pointerId); } catch (e) {}
      return;
    }
    var railEl = hit(ev, '[data-pltp-rail]');
    if (railEl) {
      var rid = railEl.getAttribute('data-pltp-rail');
      if (ui.pending && spotDef(ui.pending)) {
        var r = state.rails.filter(function (x) { return x.id === rid; })[0];
        var d = DIRS[r.rotation];
        addSpot(ui.pending, rid, (mm[0] - r.x) * d[0] + (mm[1] - r.y) * d[1]);
        return;
      }
      ui.selected = rid; renderAll();
      drag = { type: 'moveAll', last: mm, moved: false, snapshotDone: false };
      try { els.svg.setPointerCapture(ev.pointerId); } catch (e) {}
      return;
    }
    ui.selected = null; renderAll();
    drag = { type: 'pan', last: [ev.clientX, ev.clientY] };
    try { els.svg.setPointerCapture(ev.pointerId); } catch (e) {}
  });
  els.svg.addEventListener('pointermove', function (ev) {
    if (!drag) {
      if (ui.pending && spotDef(ui.pending)) {
        var h = nearestRail(toMm(ev), 220);
        ui.hover = h ? { kind: 'spot', p: railPoint(h.rail, h.posMm), r: spotDef(ui.pending).radiusMm } : null;
        renderScene();
      }
      return;
    }
    var mm = toMm(ev);
    if (drag.type === 'pan') {
      var scale = view.w / Math.max(els.svg.clientWidth, 1);
      view.x -= (ev.clientX - drag.last[0]) * scale; view.y -= (ev.clientY - drag.last[1]) * scale;
      drag.last = [ev.clientX, ev.clientY]; applyView();
    } else if (drag.type === 'moveAll') {
      var dx = snap(mm[0] - drag.last[0]), dy = snap(mm[1] - drag.last[1]);
      if (dx || dy) {
        if (!drag.snapshotDone) { history.push(snapshot()); future = []; drag.snapshotDone = true; }
        moveAll(dx, dy, true);
        drag.last = [drag.last[0] + dx, drag.last[1] + dy]; drag.moved = true;
      }
    } else if (drag.type === 'spot') {
      var hitR = nearestRail(mm, 220);
      if (!drag.snapshotDone) { history.push(snapshot()); future = []; drag.snapshotDone = true; }
      drag.moved = true;
      if (hitR) { moveSpot(drag.id, hitR.rail.id, hitR.posMm, true); drag.offRail = false; }
      else drag.offRail = true;
    }
  });
  els.svg.addEventListener('pointerup', function () {
    if (!drag) return;
    var d = drag; drag = null;
    if (d.type === 'moveAll' && d.moved) { saveLocal(); renderAll(); }
    else if (d.type === 'spot' && d.moved) {
      if (d.offRail) {
        var s = spotById(d.id);
        s.railId = d.orig.railId; s.positionMm = d.orig.positionMm;
        renderAll(); showError('Strahler können nur auf Schienen platziert werden.');
      } else { saveLocal(); renderAll(); }
    }
  });
  els.svg.addEventListener('wheel', function (ev) { ev.preventDefault(); zoom(ev.deltaY > 0 ? 1.15 : 0.87); }, { passive: false });

  /* ---------- Warenkorb ---------- */
  function planId() { return 'PL-' + new Date().toISOString().slice(0, 10).replace(/-/g, '') + '-' + Math.random().toString(36).slice(2, 7).toUpperCase(); }
  function cartItems(b, pid) {
    var qtyByVariant = {}, order = [];
    b.lines.forEach(function (ln) {
      if (ln.qty <= 0 || !ln.variantId) return;
      if (!qtyByVariant[ln.variantId]) { qtyByVariant[ln.variantId] = 0; order.push(ln.variantId); }
      qtyByVariant[ln.variantId] += ln.qty;
    });
    var summary = summaryText(b);
    return order.map(function (v) {
      return { id: v, quantity: qtyByVariant[v], properties: {
        'Planungs-ID': pid, 'Planung': 'Schienenplaner', 'System': sys().name,
        'Planungsdatum': new Date().toLocaleDateString('de-DE'), 'Zusammenfassung': summary } };
    });
  }
  function summaryText(b) {
    var spotsTxt = [];
    sys().spots.forEach(function (sd) { var n = b.spotCounts[sd.key] || 0; if (n) spotsTxt.push(n + '× ' + sd.label); });
    return b.rail1m + '× 1m, ' + b.rail2m + '× 2m, ' + b.mid + '× Mittelverbinder, ' + b.l + '× L-Verbinder, 1× Einspeiser-Set' + (spotsTxt.length ? ', ' + spotsTxt.join(', ') : '') + ' – ' + b.watt + ' W (LED)';
  }
  function addToCart() {
    var b = computeBom();
    if (b.has2m || b.notOrderable.length || b.unavailable.length || sys().orderable === false) { openRequest(); return; }
    if (!state.rails.length) return;
    var pid = planId();
    var items = cartItems(b, pid);
    var btn = els.cta.querySelector('[data-pltp-action="cart"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt …'; }
    fetch((CFG.routes && CFG.routes.cartAdd) || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) throw new Error(r.data.description || r.data.message || 'Der Warenkorb konnte nicht befüllt werden.');
        announce('Planung im Warenkorb.');
        window.location.href = (CFG.routes && CFG.routes.cart) || '/cart';
      }).catch(function (err) {
        showError('Fehler beim Hinzufügen: ' + err.message);
        if (btn) { btn.disabled = false; btn.textContent = 'Plan direkt bestellen'; }
      });
  }

  /* ---------- Projektanfrage ---------- */
  function openRequest() {
    var b = computeBom();
    var pid = planId();
    var body = [];
    body.push('--- Projektanfrage Schienenplaner ---');
    body.push('Planungs-ID: ' + pid);
    body.push('System: ' + sys().name);
    b.lines.forEach(function (ln) { if (ln.qty > 0) body.push(ln.qty + 'x ' + ln.sku + ' ' + ln.label); });
    body.push('Schienenlänge gesamt: ' + fmtM(b.totalMm));
    body.push('Strahler gesamt: ' + b.spotsTotal);
    body.push('Gesamtleistung (LED): ' + b.watt + ' W / Lichtstrom (LED): ' + b.lumen + ' lm');
    body.push('Materialwert: ' + (b.priceKnown ? money(b.priceCents) : 'auf Anfrage'));
    body.push('Verlauf: ' + runDescription());
    body.push('Einspeisepunkt: ' + (state.feedEnd === 'start' ? 'Anfang' : 'Ende'));
    body.push('Planungsdaten: ' + snapshot());
    els.dialog.querySelector('[name="contact[body]"]').value = body.join('\n');
    els.dialog.querySelector('[data-pltp-plan-id]').textContent = pid;
    if (typeof els.dialog.showModal === 'function') els.dialog.showModal();
    else els.dialog.setAttribute('open', 'open');
  }
  if (/contact_posted=true/.test(window.location.search)) {
    var okEl = q('.pl-tp-request-ok'); if (okEl) { okEl.hidden = false; try { okEl.scrollIntoView(); } catch (e) {} }
  }

  /* ---------- Test-API ---------- */
  window.PLTrackPlanner = {
    getState: function () { return clone(state); },
    getBom: computeBom,
    goToStep: goToStep, getStep: function () { return state.currentStep; },
    selectSystem: selectSystem, changeSystem: changeSystem,
    addFirstRail: addFirstRail, attachRail: attachRail, validRel: validRel, relToStored: relToStored,
    checkCandidate: checkCandidate, addSpot: addSpot, moveSpot: moveSpot, deleteSpot: deleteSpot,
    deleteRail: deleteRail, rotateSpot: rotateSpot, setFeedEnd: setFeedEnd,
    undo: undo, redo: redo, resetPlanning: resetPlanning, applyTemplate: applyTemplate,
    spotPlus: spotPlus, spotMinus: spotMinus, openChooser: openChooser, fitView: fitView,
    cartItems: function () { var b = computeBom(); return cartItems(b, 'TEST'); },
    runDescription: runDescription,
    _config: CFG, _messages: { closed: MSG_CLOSED }
  };

  /* ---------- Start ---------- */
  window.addEventListener('resize', applyView);
  applyView(); renderAll(); tryOfferResume();
})();
